import Xyz from "./xyz";

function mapboxbase() {
  const tk =
    "pk.eyJ1IjoiZ2F2aW5jaHUiLCJhIjoiY2t6cHEwcXc5NjJ6YjJ4cHJ3MjJmczJmMyJ9.FVn8-JKooqJ83u-n7x79RA";
  return new Xyz({
    attribution: "Thanks To Mapbox",
    url: `https://api.mapbox.com/v4/mapbox.satellite/{z}/{x}/{y}.jpg?access_token=${tk}`,
    maxZoom: 15,
  });
}

export default mapboxbase;
